import Environment from "../services/interfaces/Environment";

const _environment: Environment = {
    isProduction: true,
    targetClient: 'https://chasethefox.com/',
    targetServer: 'https://chasethefox.com/',
    targetCdn: 'https://cdn.chasethefox.com/',
};

export default _environment;